import {ref, Ref} from 'vue';

type Callback = () => void;
export class EditorDialogApiLoginStoreControllerClass {
	private static _instance: EditorDialogApiLoginStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogApiLoginStoreControllerClass());
	}

	private _displayed = ref(false);
	private _errorMessage: Ref<string | null> = ref(null);
	private _callback: Callback | undefined;
	private constructor() {}

	displayed(): boolean {
		return this._displayed.value;
	}
	errorMessage(): string | null {
		return this._errorMessage.value;
	}

	//
	// methods
	//
	async show() {
		return new Promise((resolve) => {
			this._displayed.value = true;
			this._callback = () => {
				resolve(undefined);
			};
		});
	}
	hide() {
		this._displayed.value = false;
	}
	executeCallback() {
		if (!this._callback) {
			return;
		}
		const callback = this._callback;
		this._callback = undefined;
		callback();
	}
	setErrorMessage(message: string | null) {
		this._errorMessage.value = message;
	}
}

export const EditorDialogApiLoginStoreController = EditorDialogApiLoginStoreControllerClass.instance();
